export default {
  get_base_info: "/index/api/base_info", // 平台基本信息
  do_login: "/index/api/do_login", // 登录
  do_register: "/index/api/do_register", // 注册
  get_banners: "/index/api/banner", // 轮播图
  get_hotel_list: "/index/api/get_deal_goodslist", // 酒店列表
  get_hotel_detail: "/index/api/get_deal_goodsdetail", // 酒店详情
  get_user_info: "/index/api/user_info ", // 用户信息
  do_deposit: "/index/api/do_deposit", // 提现
  set_login_pwd: "/index/api/set_pwd", // 更新登录密码
  set_pay_pwd: "/index/api/set_pwd2", // 更新支付密码
  get_notice: "/index/api/get_notice", // 首页滚动通知、提现规则、酒店刷单规则
  get_goods_list: "/index/api/get_goodslist", // 选妃列表
  get_goods_detail: "/index/api/get_goodsdetail", // 选妃详情
  get_bank_info: "/index/api/get_bank_info", // 银行卡信息
  set_bank_info: "/index/api/set_bank_info", // 更新银行卡
  get_message: "/index/api/get_message", // 系统公告
  get_caiwu: "/index/api/caiwu", // 资金明细
  get_withdrawal: "/index/api/withdrawal", // 提现列表
  submit_order: "/index/api/submit_order", // 抢单
  get_order_info: "/index/api/order_info", // 订单详情
  do_order: "/index/api/do_order", // 支付
  get_order_list: "/index/api/order_list", // 刷单订单列表
  get_income: "/index/api/get_income", // 用户收益
  get_article: "/index/api/getarticle", // 社区动态
};
